import $api from "../Api";
import Endpoints from "../Endpoints";
import normalizeBaseResult from "../helpers/baseResult";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const decodeArrayBuffer = (value) => {
  try {
    return new TextDecoder("utf-8").decode(value);
  } catch (error) {
    return "";
  }
};

const resolveFileName = (contentDisposition, fallback) => {
  if (!contentDisposition) return fallback;
  const encoded = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.replace(/["']/g, ""));
    } catch (error) {
      return encoded;
    }
  }
  return contentDisposition.match(/filename="?([^";]+)"?/i)?.[1] || fallback;
};

const downloadFile = async (url, fallbackFileName) => {
  const headers = { "Content-Type": "application/json" };
  if ($api.token && $api.token !== "FAIL") {
    headers.Authorization = `Bearer ${$api.token}`;
  }

  try {
    const response = await axios.get(`${BASE_URL}${url}`, {
      headers,
      responseType: "arraybuffer",
      validateStatus: () => true,
    });
    const contentType = response.headers["content-type"] || "";

    if (
      response.status < 200 ||
      response.status >= 300 ||
      contentType.includes("application/json")
    ) {
      const parsed = JSON.parse(decodeArrayBuffer(response.data) || "{}");
      return normalizeBaseResult(parsed);
    }

    return {
      isSuccess: true,
      message: 1,
      exceptionMessage: null,
      data: {
        blob: new Blob([response.data], { type: contentType }),
        contentType,
        fileName: resolveFileName(
          response.headers["content-disposition"],
          fallbackFileName
        ),
      },
    };
  } catch (error) {
    return normalizeBaseResult(null);
  }
};

/**
 * Satışın aktif checkout'u için e-Fatura/e-Arşiv belgesi oluşturur.
 * localDocumentId tekrar üretilebilir olmalıdır; aynı değerle tekrar çağrı
 * provider'a ikinci bir belge göndermez.
 *
 * @param {{
 *   saleId: string,
 *   localDocumentId: string,
 *   issueDateUtc: string,
 *   recipientTaxNumber: string,
 *   recipientAlias?: string|null,
 *   scenario: 0|1|2,
 *   deliveryKind: 0|1,
 *   internetSale?: object|null,
 *   notificationEmail?: string|null,
 *   currency: string,
 *   lines: Array<{
 *     description: string,
 *     quantity: number,
 *     unitPrice: number,
 *     taxRate: number,
 *     discountAmount: number
 *   }>
 * }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.EInvoice.Create(), form);
  return normalizeBaseResult(response);
};

/** @param {{ params: { invoiceId: string } }} options */
export const Get = async (options) => {
  const response = await $api.get(Endpoints.EInvoice.Get(options));
  return normalizeBaseResult(response);
};

/**
 * @param {{ query?: {
 *   search?: string,
 *   saleId?: string,
 *   scenario?: "Automated"|"EInvoice"|"EArchive",
 *   status?: string,
 *   issueDateFromUtc?: string,
 *   issueDateToUtc?: string,
 *   page?: number,
 *   limit?: number
 * } }} options
 */
export const GetAll = async (options) => {
  const response = await $api.get(Endpoints.EInvoice.GetAll(options));
  return normalizeBaseResult(response);
};

/** @param {{ params: { saleId: string } }} options */
export const GetBySaleId = async (options) => {
  const response = await $api.get(Endpoints.EInvoice.GetBySaleId(options));
  return normalizeBaseResult(response);
};

/** @param {{ params: { invoiceId: string } }} options */
export const RefreshStatus = async (options) => {
  const response = await $api.post(Endpoints.EInvoice.RefreshStatus(options));
  return normalizeBaseResult(response);
};

/** @param {{ params: { invoiceId: string } }} options */
export const GetXml = (options) =>
  downloadFile(Endpoints.EInvoice.GetXml(options), "e-invoice.xml");

/** @param {{ params: { invoiceId: string } }} options */
export const GetPdf = (options) =>
  downloadFile(Endpoints.EInvoice.GetPdf(options), "e-invoice.pdf");

/** @param {{ params: { invoiceId: string } }} options */
export const CancelEArchive = async (options) => {
  const response = await $api.post(Endpoints.EInvoice.CancelEArchive(options));
  return normalizeBaseResult(response);
};

/** @param {{ params: { invoiceId: string } }} options */
export const Retry = async (options) => {
  const response = await $api.post(Endpoints.EInvoice.Retry(options));
  return normalizeBaseResult(response);
};

export default {
  Create,
  Get,
  GetAll,
  GetBySaleId,
  RefreshStatus,
  GetXml,
  GetPdf,
  CancelEArchive,
  Retry,
};
